import { Row, Col, Input, InputNumber } from 'antd'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import OrderHelper from '../../../../../services/orderHelper'

import Item from '../item'
import './styles.css'

class Table extends Component {
    listItems = []
    state = {
        splitOrderValue: 0,
        totalValues: 0,
        totalQuantity: 0,
        quantity: 0
    }

    componentDidMount() {
        const { splitedOrder: { OrderDetails } } = this.props

        this.listItems = OrderDetails.map(item => {
            return {
                ID: item.ID,
                totalValue: '',
                quantity: 0
            }
        })

        // get total item's values and quantity to check split button status later on
        const totalValues = OrderDetails.map(order => order.QuantityOrderedIN * order.UnitPriceFL).reduce((totalValue, value) => totalValue + value)
        const totalQuantity = OrderDetails.map(order => order.QuantityOrderedIN).reduce((totalValue, value) => totalValue + value)

        this.setState({
            totalValues,
            totalQuantity
        })
    }

    onChange = (item) => {
        const { updateListItems } = this.props
        const { totalValues } = this.state

        // update new item to list
        this.listItems = [
            ...this.listItems.filter(i => i.ID !== item.ID),
            item
        ]

        // caculate total splited values and quantity to check split button status
        const splitOrderValue = this.listItems.map(i => i.totalValue).reduce((sum, value) => +sum + Number(value)) || 0
        this.setState({
            splitOrderValue,
            splitOrderTotalQuantity: this.listItems.map(i => i.quantity).reduce((sum, value) => +sum + Number(value)) || 0,
            leftOrderValue: totalValues - splitOrderValue
        }, () => {
            this.updateSplitButtonStatus()
            updateListItems(this.listItems)
        })
    }

    updateSplitButtonStatus = () => {
        const { totalValues, splitOrderValue, totalQuantity, splitOrderTotalQuantity } = this.state
        const { updateSplitButtonStatus } = this.props
        let isDisabled = false

        // item not entered value yet or value is invalid
        if (this.listItems.some(item => item.quantity === '' || isNaN(item.quantity) || item.isQuantityError)) {
            isDisabled = true
        }

        // total splited quantity equal or bigger than total quantity of original items
        if (totalQuantity <= splitOrderTotalQuantity) {
            isDisabled = true
        }

        // all item's quantity value must be bigger than 0
        if (!this.listItems.some(item => Number(item.quantity) > 0)) {
            isDisabled = true
        }

        // update split button status
        this.props.updateSplitButtonStatus(isDisabled)
    }

    renderRow = () => {
        const { splitedOrder: { OrderDetails } } = this.props

        return OrderDetails.map((value, key) => {
            const item = {
                ...value,
                adjustedValue: OrderHelper.item.priceAdjusted(value)
            }

            return <Item
                ref={ref => { this.refItem = ref }}
                itemData={item}
                key={item.ID}
                no={key + 1}
                onChange={this.onChange}
            />
        })
    }

    render() {
        const { splitedOrder: { OrderDetails } } = this.props
        const { splitOrderValue, totalValues, leftOrderValue } = this.state

        if (!OrderDetails.length) return null

        return (
            <div className="item-name-table-container">
                <div className="warp-title">
                    <Row>
                        <Col className="info-title" span={12}>
                            <h1>ITEM INFORMATION</h1>
                        </Col>
                        <Col className="info-order-value" span={5}>
                            <div className="order-value-title">
                                Order Value
                            </div>
                            <InputNumber
                                className="text-right black-text"
                                precision={2}
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                disabled
                                value={
                                    leftOrderValue === undefined
                                        || leftOrderValue === ''
                                        || isNaN(leftOrderValue)
                                        ? totalValues
                                        : leftOrderValue
                                }
                                style={{ width: '50%' }}
                            />
                        </Col>
                        <div className="float-right">
                            <div className="split-title">
                                Split
                            </div>
                            <div className="order-value-title">
                                Order Value
                            </div>
                            <InputNumber
                                className="text-right black-text gray-color"
                                precision={2}
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                value={splitOrderValue}
                                disabled
                                style={{ width: '70%' }}
                            />
                        </div>
                    </Row>
                </div>
                <table className="item-name-table">
                    <thead>
                        <tr>
                            <th style={{ width: '45px' }}>NO</th>
                            <th style={{ width: '150px' }}>SKU</th>
                            <th style={{ width: '175px' }}>CHANNEL ITEM CODE</th>
                            <th style={{ width: '190px' }}>ITEM NAME(EN)</th>
                            {/* <th style={{ width: '25px' }}></th> */}
                            <th style={{ width: '150px' }}>DECLARED VALUE</th>
                            <th style={{ width: '80px' }}>QTY</th>
                            <th style={{ width: '140px' }}>TOTAL VALUE</th>
                            <th style={{ width: '80px', minWidth: '75px', backgroundColor: 'rgb(0, 176, 240)', color: '#FFF' }}>QTY</th>
                            <th style={{ width: 'auto', backgroundColor: 'rgb(0, 176, 240)', color: '#FFF' }}>TOTAL VALUE</th>
                        </tr>
                    </thead>
                    <tbody>{this.renderRow()}</tbody>
                </table>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        splitedOrder: state.ordersReducer.splitedOrder,
    }
}

export default connect(
    mapStateToProps,
)(Table)



// WEBPACK FOOTER //
// ./src/containers/orders/components/split-modal/split-table/index.js